<!--
  @Description 员工档案
  @Date 2022-02-23
  @Author liushuo
-->
<template>
  <div class="container">
    <homeHeader title="员工档案"></homeHeader>
    <div class="main">
      <div class="card">
        <div class="toolbar-dv">
          <toolBarBtn
            :parentData="this"
            :buttonVisible="buttonVisible"
            :moreButtonList="moreButtonList"
            ref="toolBarBtn"
          ></toolBarBtn>
        </div>
        <div class="table-dv">
          <vxe-grid
            border
            resizable
            keep-source
            size="mini"
            :column-config="{ minWidth: '80px' }"
            :edit-rules="validRules"
            :cell-class-name="cellClassName"
            :columns="tableColumns"
            :height="tableHeight"
            ref="xTable"
            :mouse-config="{ area: true, extension: true }"
            :edit-config="{
              trigger: 'dblclick',
              mode: 'cell',
              activeMethod: activeMethod
            }"
            highlight-hover-row
            highlight-current-row
            :keyboard-config="{
              isArrow: true,
              isEnter: true,
              isTab: true,
              enterToTab: true,
              isClip: true,
              isEdit: true,
              editMethod: editMethod
            }"
            :data="tableData"
            :menu-config="{
              body: { options: bodyMenus },
              visibleMethod: visibleMethod
            }"
            @menu-click="contextMenuClickEvent"
            @cell-menu="cellContextMenuEvent"
          ></vxe-grid>
        </div>
      </div>
    </div>
    <!-- 导入 -->
    <Import ref="Import" @sureImportBack="sureImportBack"></Import>
    <!-- 自定义右键 -->
    <CustomContentMenu ref="CustomContentMenuRef" @backContextMenu="contextMenuClickEvent" />
    <!-- <PickPosition
      ref="PickPosition"
      :positionOptions="combobox.roleName"
      :visiblePosition="selectVisiblePositionArr"
      @sureBackPosition="sureBackPosition"
    /> -->
  </div>
</template>

<script>
import Import from './import'
import { placeInfo } from '@/public/utils/globalVariable'
import CustomContentMenu from '@/components/common/MyContextMenu.vue'

export default {
  components: {
    Import,
    CustomContentMenu
  },
  created() {
    this.InitColumn()
  },
  activated() {},
  mounted() {
    this.initRightForEdit()
    this.BindData()
    this.BindComBox()
  },
  data() {
    return {
      tableData: [],
      // 列设置
      tableColumns: [],
      buttonVisible: {
        save: true,
        add: true,
        lock: false, // 锁定按钮是否显示
        unlock: false, // 解锁按钮是否显示
        update: false,
        delete: false,
        sort: false, // 排序按钮是否显示
        search: false, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      },
      validRules: {
        userCompany: [
          { required: true, message: '请选择单位', trigger: 'change' },
          {
            min: 0,
            max: 64,
            message: '单位长度应在 0 到 64 个字符',
            trigger: 'change'
          }
        ],
        deptName: [
          {
            min: 0,
            max: 16,
            message: '部门长度应在 0 到 16 个字符',
            trigger: 'change'
          }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'change' },
          {
            min: 0,
            max: 5,
            message: '姓名长度应在 0 到 5 个字符',
            trigger: 'change'
          }
        ],
        num: [
          { required: true, message: '请输入用户名', trigger: 'change' },
          {
            min: 0,
            max: 32,
            message: '用户名长度应在 0 到 32 个字符',
            trigger: 'change'
          }
        ],
        tel: [
          { required: true, message: '请输入手机号', trigger: 'change' },
          {
            validator: this.validatePhone,
            message: '请输入正确电话号码',
            trigger: 'change'
          },
          {
            min: 0,
            max: 11,
            message: '手机号长度应在 0 到 11 个字符',
            trigger: 'change'
          }
        ],
        city: [
          { required: true, message: '请输入所在城市', trigger: 'change' },
          { validator: this.validCity, trigger: 'change' },
          {
            min: 0,
            max: 64,
            message: '所在城市长度应在 0 到 64 个字符',
            trigger: 'change'
          }
        ],
        roleName: [
          { required: true, message: '请选择角色', trigger: 'change' },
          {
            min: 0,
            max: 2,
            message: '角色长度应在 0 到 2 个字符',
            trigger: 'change'
          }
        ],
        weiXinID: [
          {
            min: 0,
            max: 64,
            message: '企业微信号长度应在 0 到 64 个字符',
            trigger: 'change'
          }
        ],
        feiShuID: [
          {
            min: 0,
            max: 64,
            message: '飞书账号应在 0 到 64 个字符',
            trigger: 'change'
          }
        ],
        dingDingID: [
          {
            min: 0,
            max: 64,
            message: '钉钉账号应在 0 到 64 个字符',
            trigger: 'change'
          }
        ]
      },
      bodyMenus: [
        [
          {
            code: 'sex',
            name: '男'
          },
          {
            code: 'sex',
            name: '女'
          }
          // {
          //   code: 'post',
          //   name: '选择职位'
          // },
          // {
          //   code: 'clearPosition',
          //   name: '清空'
          // }
        ]
      ],
      // 拓展按钮
      moreButtonList: [],
      // check全选查找值
      checkBoxAll: false,
      //右键缓存
      areas: [],
      // 当前选中列
      colProperty: '',
      selectVisiblePositionArr: [],
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      // 是否修改
      IfExistModify: false,
      // 校验
      errIndex: []
    }
  },
  methods: {
    cellContextMenuEvent({ column }, event) {
      this.areas = this.$refs.xTable.getCellAreas()
      if (column.property === 'userCompany') {
        // 在这里打开
        let eve = event || window.event
        const x = eve.clientX
        const y = eve.clientY
        this.$refs.CustomContentMenuRef.options = this.bodyMenus[0].filter(item => {
          return ['userCompany'].includes(item.code)
        })
        this.$refs.CustomContentMenuRef.mouseX = x
        this.$refs.CustomContentMenuRef.mouseY = y
        this.$refs.CustomContentMenuRef.formVisible = true
        setTimeout(() => {
          this.$refs.CustomContentMenuRef.setposition()
        }, 25)
      }
    },
    // 右键打开菜单
    contextMenuClickEvent({ menu }) {
      this.areas.forEach(a => {
        for (let row of a.rows) {
          for (let column of a.cols) {
            if (column.property === menu.code) {
              row[column.property] = menu.name
            }
          }
        }
      })
    },
    // 快捷键
    visibleMethod({ options, column }) {
      options.forEach(list => {
        list.forEach(item => {
          if (!column || !this.isCanEdit) {
            item.visible = false
          } else {
            // item.visible = item.code === column.property
            item.visible = item.code === column.property && column.property !== 'userCompany'
          }
        })
      })
      return true
    },
    // 根据权限，初始化控件是否显示
    initRightForEdit() {
      this.buttonVisible.save = this.isCanEdit
      this.buttonVisible.add = this.isCanEdit

      // 有编辑权限才可以显示如下按钮
      if (this.isCanEdit) {
        this.moreButtonList = [
          {
            name: '重置密码',
            icon: 'el-icon-key',
            event: 'handleResetPassword'
          },
          {
            icon: 'iconfont fjyk-daoru-03-copy',
            name: '导入',
            event: 'import'
          }
        ]
      }
    },
    // 获取数据
    async BindData() {
      this.tableData = []
      const { data: res } = await this.$http.post('/Bugs/YKUser/list', {
        pageIndex: 1,
        pageSize: 99999,
        seeType: this.Authority.seeType
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.tableData = res.data.rows.map(item => {
        item.isSave = true
        item.isCheck = false
        return item
      })
    },
    // 刷新数据
    refresh() {
      this.BindData()
    },
    // 绑定下拉框
    async BindComBox() {
      const { data: selectRes } = await this.$http.get('/Bugs/YKUser/select-item')
      if (selectRes.isSuccess) {
        for (let item of selectRes.data) {
          this.bodyMenus[0].push(item)
        }
      }
    },
    // 重置密码
    async handleResetPassword() {
      const selectRecords = this.getCheckRecords(this.tableData)
      const idList = this.getIDList(selectRecords)

      if (selectRecords.length === 0) {
        this.$message.warning('请选择需要重置密码的人员!')
        return
      }

      const { data: res } = await this.$http.put(`/Bugs/YKUser/resetpwd`, idList)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success('操作成功!')
      this.clearAllCheck(this.tableData)
    },
    // 获取已勾选的数据
    getCheckRecords(arr) {
      return arr.filter(row => row.isCheck)
    },
    // 清除勾选状态
    clearAllCheck(arr) {
      // 数据行的复选框
      arr.forEach(row => {
        row.isCheck = false
      })
      // 表头的复选框
      this.checkBoxAll = false
    },
    // 保存所拉选的行ID
    getIDList(arr) {
      let res = []
      // 将行id保存
      arr.forEach(row => {
        res.push(row.id)
      })
      return res
    },
    // 初始化
    InitColumn() {
      this.tableColumns = [
        {
          type: 'seq',
          width: '50',
          className: 'seqErrorVaildClass',
          slots: {
            default: ({ row }) => {
              if (row.ifRepeat) {
                return [
                  <el-tooltip class='tooltipItem' effect='light' content={row.repeatText} placement='right'>
                    <div style='width: 100%; height: 100%'>
                      <span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>
                    </div>
                  </el-tooltip>
                ]
              } else {
                return [<span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>]
              }
            }
          }
        },
        {
          field: 'delete',
          title: '删除',
          width: '50',
          visible: this.isCanEdit,
          align: 'center',
          slots: {
            default: ({ row }) => {
              return [
                <i
                  id='vxeDelete'
                  class='el-icon-delete-solid'
                  onClick={() => {
                    this.handleCellDelete(row)
                  }}
                ></i>
              ]
            }
          }
        },
        {
          width: '50px',
          visible: this.isCanEdit,
          slots: {
            default: ({ row }) => {
              return [<vxe-checkbox v-model={row.isCheck} disabled={!row.isSave}></vxe-checkbox>]
            },
            header: () => {
              return [
                <vxe-checkbox
                  v-model={this.checkBoxAll}
                  onChange={() => {
                    this.checkBoxChangeAll()
                  }}
                />
              ]
            }
          }
        },
        {
          field: 'userCompany',
          title: '单位',
          editRender: { name: 'input', attrs: { disabled: true } },
          filters: [
            { data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          field: 'deptName',
          title: '部门',
          editRender: { name: 'input' },
          filters: [
            { data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          field: 'name',
          title: '姓名',
          editRender: { name: 'input' },
          filters: [
            { data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          field: 'num',
          title: '用户名',
          editRender: { name: 'input' },
          filters: [
            { data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          field: 'tel',
          title: '手机号',
          editRender: { name: '$input' },
          filters: [
            { data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          field: 'city',
          title: '所在城市',
          editRender: { name: 'input' },
          filters: [
            { data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          field: 'roleName',
          title: '角色',
          editRender: { name: 'input', attrs: { disabled: true } },
          filters: [
            { data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          field: 'weiXinID',
          title: '企业微信号',
          editRender: { name: 'input' }
        },
        {
          field: 'feiShuID',
          title: '飞书账号',
          editRender: { name: 'input' }
        },
        {
          field: 'dingDingID',
          title: '钉钉账号',
          editRender: { name: 'input' }
        }
      ]
    },
    // 全选
    checkBoxChangeAll() {
      const tableData = this.$refs.xTable.getTableData().fullData
      for (let item of tableData) {
        if (item.isSave) {
          item.isCheck = this.checkBoxAll
        }
      }
    },
    add() {
      this.$refs.xTable.insertAt({ id: 0, isCheck: false }, -1)
    },
    save() {
      const that = this
      // 保存dgv数据
      that.validEnter().then(async result => {
        if (result) {
          let insertRecords = that.$refs.xTable.getInsertRecords()
          let removeRecords = that.$refs.xTable.getRemoveRecords()
          let updateRecords = that.$refs.xTable.getUpdateRecords()
          // that.form.setName = that.setName
          // let form = { ...that.form }
          let detailList = []
          for (let item of insertRecords) {
            item.id = 0
            detailList.push(item)
          }
          for (let item of removeRecords) {
            item.id = item.id > 0 ? 0 - item.id : item.id
            detailList.push(item)
          }
          for (let item of updateRecords) {
            detailList.push(item)
          }
          detailList = that.removeArrayNull(detailList)
          if (detailList.length === 0) {
            that.$XModal.alert({
              message: that.messageConfig.emptyDataForSave,
              status: 'error'
            })
            return
          }
          // 保存节点信息
          const { data: res } = await that.$http.put('/Bugs/YKUser', detailList)
          if (res.isSuccess) {
            that.BindData()
            that.$message.success(res.data)
            that.IfExistModify = false
          } else {
            that.$message.error(res.errorMessage)
          }
        }
      })
    },
    // 验证
    async validEnter() {
      let flag = true
      this.errIndex = []
      this.removeEmptyForTable(this.$refs.xTable)

      // 判断重复数据（用户名）
      this.repeatForTable(this.errIndex, this.$refs.xTable, ['num'])
      if (this.errIndex.length > 0) {
        flag = false
      }

      const errMap = await this.$refs.xTable.fullValidate().catch(errMap => errMap)
      if (errMap) {
        Object.values(errMap).forEach(errList => {
          errList.forEach(params => {
            let { row, columnIndex, rules } = params
            rules.forEach(() => {
              this.errIndex.push({
                _XID: row._XID,
                columnIndex: columnIndex
              })
            })
          })
        })
      }
      if (this.errIndex.length > 0) {
        flag = false
      }
      if (!flag) {
        this.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 删除行
    handleCellDelete(row) {
      if (row.num === 'admin') {
        this.$message.error('管理员不可删除')
        return
      }
      this.$confirm('确定要删除本行吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$refs.xTable.remove(row)
          this.IfExistModify = true
        })
        .catch(() => {})
    },
    // cell激活控制
    activeMethod({ column }) {
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      if (!this.isCanEdit) {
        return false
      }
      return true
    },
    // cell编辑控制
    editMethod({ row, column, $table }) {
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      if (!this.isCanEdit) {
        return false
      }
      row[column.property] = null
      $table.setActiveCell(row, column.property)
      return true
    },
    // 导入
    import() {
      this.$refs.Import.isShow = !this.$refs.Import.isShow
    },
    // 返回导入值 | 明细主信息
    async sureImportBack(selectRecords) {
      if (selectRecords.length > 0) {
        this.$refs.xTable.insertAt(selectRecords, -1)
      }
    },
    // 单元格设置样式,错误提示
    cellClassName({ row, columnIndex }) {
      var a = this.errIndex.find(item => {
        return item._XID === row._XID && item.columnIndex === columnIndex
      })
      if (a) {
        return 'cell-valid'
      }
    },
    // 校验城市名字有效性
    validCity({ cellValue }) {
      return new Promise((resolve, reject) => {
        let root = placeInfo[0]
        // 广度优先遍历
        const bfs = root => {
          // 根节点入队
          let q = [root]
          while (q.length > 0) {
            // 根节点出队并访问
            const n = q.shift()
            if (n.value === cellValue) {
              return true
            }
            n.children?.forEach(child => {
              q.push(child)
            })
          }
          return false
        }

        bfs(root) ? resolve() : reject(new Error('请输入有效的城市'))
      })
    }
  },
  computed: {
    tableHeight() {
      let isSearchForm = this.searchFormVisible
      // 若有查询框，则共有四段 margin 否则只有表格的两段 margin
      let topBottomMargin = 20
      let tableMargin = isSearchForm
        ? this.heightConfig.mainMargin * 4
        : this.heightConfig.mainMargin * 2 + topBottomMargin
      let isToolBar = true
      return this.tableHeightComputed(tableMargin, isSearchForm, isToolBar)
    },
    // 单位名称列表
    userCompanyList() {
      let res = []
      this.bodyMenus[0].forEach(item => {
        if (item.code === 'userCompany') {
          res.push(item.value)
        }
      })
      return res
    },
    // 可编辑条件：岗位为 [管理]
    isCanEdit() {
      return this.$store.state.userInfo.gangWei === '管理'
    }
  }
}
</script>

<style lang="less" scoped>
@main-margin: 15px;
.main {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - @header-height);
  overflow: hidden;
}
.card {
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
}
.toolbar-dv {
  padding: 10px;
}

.table-dv {
  padding: @topBottomMargin;
}

.vxe-checkbox {
  width: 15px !important;
}
</style>
